import { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { useCart } from "../context/CartContext";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import { Check, AlertCircle, Loader2 } from "lucide-react";

export default function CheckoutSuccess() {
    const [params] = useSearchParams();
    const sessionId = params.get("session_id");
    const [status, setStatus] = useState("polling");
    const { clear } = useCart();
    const cleared = useRef(false);

    useEffect(() => {
        if (!sessionId) {
            setStatus("error");
            return;
        }
        let attempts = 0;
        const poll = async () => {
            if (attempts >= 8) {
                setStatus("timeout");
                return;
            }
            try {
                const { data } = await api.get(`/payments/status/${sessionId}`);
                if (data.payment_status === "paid") {
                    setStatus("paid");
                    if (!cleared.current) {
                        clear();
                        cleared.current = true;
                    }
                    return;
                }
                if (data.status === "expired") {
                    setStatus("expired");
                    return;
                }
            } catch (err) {
                // Polling will retry; only log unexpected errors
                if (err?.response?.status && err.response.status !== 404) {
                    console.warn("Checkout status poll failed:", err.response.status);
                }
            }
            attempts += 1;
            setTimeout(poll, 2000);
        };
        poll();
        // eslint-disable-next-line
    }, [sessionId]);

    const content = {
        polling: { Icon: Loader2, color: "text-wine", title: "A confirmar o pagamento…", desc: "Estamos a validar a sua transação.", spin: true },
        paid: { Icon: Check, color: "text-vineyard", title: "Pagamento confirmado", desc: "Obrigado! A sua encomenda foi recebida e em breve estará a caminho." },
        timeout: { Icon: AlertCircle, color: "text-gold-deep", title: "A processar", desc: "O pagamento está a demorar mais que o normal. Receberá um email de confirmação." },
        expired: { Icon: AlertCircle, color: "text-destructive", title: "Sessão expirada", desc: "Por favor, refaça o pagamento." },
        error: { Icon: AlertCircle, color: "text-destructive", title: "Erro", desc: "Não foi possível obter o estado do pagamento." },
    }[status];

    return (
        <>
            <Navbar variant="light" />
            <section className="pt-40 pb-32 bg-beige-natural min-h-[70vh]">
                <div className="container-edge max-w-xl mx-auto text-center" data-testid="checkout-status">
                    <content.Icon className={`h-14 w-14 mx-auto ${content.color} ${content.spin ? "animate-spin" : ""}`} strokeWidth={1.5} />
                    <h1 className="mt-8 font-heading text-5xl text-wine-dark">{content.title}</h1>
                    <p className="mt-4 text-wine-dark/70">{content.desc}</p>
                    <div className="mt-12 flex flex-wrap items-center justify-center gap-4">
                        <Link to="/conta" className="btn-wine">As minhas encomendas</Link>
                        <Link to="/marketplace" className="btn-wine-outline">Continuar a comprar</Link>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}
